<template>
    <el-card class="checkin-overview-card">
        <div class="card-header">
            <i class="el-icon-user-solid"></i>
            <span class="card-title">今日打卡概览</span>
        </div>
        <div class="checkin-overview-list">
            <div class="overview-header">
                <div class="header-item">人员姓名</div>
                <div class="header-item">温度是否异样</div>
                <div class="header-item">晨检时间</div>
                <div class="header-item">人脸图片</div>
            </div>
            <!-- 滚动列表的视窗容器 -->
            <div class="marquee-container">
                <div class="overview-body">
                    <div class="overview-row" v-for="(item, index) in checkinList" :key="index">
                        <div class="body-item">{{ item.realName }}</div>
                        <div class="body-item">
                            <el-tag
                                :type="item.abnormalTemp == 1 ? 'danger' : (item.abnormalTemp == 0 ? 'success' : 'info')">
                                {{ item.abnormalTemp == 1 ? '异常' : item.abnormalTemp == 0 ? '正常' : '未检测' }}
                            </el-tag>
                        </div>
                        <div class="body-item">{{ item.checkTime }}</div>
                        <div class="body-item">
                            <div class="image-container">
                                <img v-if="item.faceUrl" :src="item.faceUrl" alt="人脸图片" class="preview-image"
                                    @click="previewImage(item.faceUrl, '人脸图片')">
                                <div v-else class="no-image">
                                    <i class="el-icon-picture-outline"></i>
                                    <span>暂无图片</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="empty-tip" v-if="checkinList.length === 0">
                        暂无今日晨检打卡记录
                    </div>
                </div>
            </div>
        </div>
    </el-card>
</template>

<script>
export default {
    props: {
        checkinList: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        previewImage(url, title) {
            this.$emit('preview-image', url, title);
        }
    }
};
</script>

<style lang="scss" scoped>
.card-header {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 600;
    color: #333;
    padding-bottom: 10px;
    border-bottom: 1px solid #ebeef5;
    margin-bottom: 15px;

    i {
        font-size: 20px;
        margin-right: 10px;
        color: #409EFF;
    }
}

// --- 自动滚动列表样式 ---
.checkin-overview-list {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    /* 隐藏滚动条 */

    .overview-header {
        display: flex;
        background-color: #f8f9fa;
        font-weight: 600;
        padding: 12px 0;
        border-bottom: 1px solid #e8e8e8;
        z-index: 10;

        .header-item {
            flex: 1;
            text-align: center;
            color: #333;
        }
    }

    .marquee-container {
        flex: 1;
        overflow: hidden;
        /* 关键：作为视窗，隐藏超出的内容 */
    }

    .overview-body {
        // 关键：应用动画
        animation: scroll-up 30s linear infinite;
        height: 100%;

        // 鼠标悬停时暂停动画
        &:hover {
            animation-play-state: paused;
        }

        .overview-row {
            display: flex;
            align-items: center;
            padding: 10px 0;
            border-bottom: 1px dashed #f0f0f0;

            &:hover {
                background-color: #f8f9fa;
            }

            .body-item {
                flex: 1;
                text-align: center;
                color: #666;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }

        .empty-tip {
            text-align: center;
            padding: 50px 0;
            color: #999;
        }
    }
}

// 定义滚动动画
@keyframes scroll-up {
    0% {
        transform: translateY(0);
    }

    100% {
        // 向上移动自身的 100% 高度
        transform: translateY(-100%);
    }
}

.image-container {
    .preview-image {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        cursor: pointer;
        object-fit: cover;
    }

    .no-image {
        display: flex;
        flex-direction: column;
        align-items: center;
        color: #999;
        font-size: 12px;

        i {
            font-size: 16px;
            margin-bottom: 2px;
        }
    }
}
</style>